import { BehaviorSubject, Observable} from 'rxjs';
//import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { throwError } from 'rxjs';

import { catchError, map, tap} from 'rxjs/operators';
import { Injectable }     from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';

import { Router }         from '@angular/router';
import { first }          from 'rxjs/operators';
//import { JwtHelper }      from 'angular2-jwt';
import { JwtHelperService } from "@auth0/angular-jwt";
import { Credentials, 
  UserAdm , Scope, Ops }  from '../../_models/index';
import { environment }    from '../../../environments/environment';
//import { Http, Response, 
//Headers, RequestOptions } from '@angular/http';
import * as CryptoJS      from 'crypto-js';
//import { JwtHelper } from 'angular2-jwt';

@Injectable()
export class AdmAuthService {
  public userAdmin: Observable<UserAdm>;  private currentUserSubject: BehaviorSubject<UserAdm>;
  //public id_token: string;
  public listReferralTypes  = [];
  constructor(
    private httpClient: HttpClient, 
    //private jwtHelper: JwtHelper, 
    private jwtHelperService: JwtHelperService,
    private router: Router) { 
      //this.currentUserSubject = new BehaviorSubject<UserAdm>(JSON.parse(this.b64DecodeUnicode(sessionStorage.getItem('onreference_adm'))));
      this.currentUserSubject = new BehaviorSubject<UserAdm>(
        this.safeParse('onreference_org', null)
      );

      this.userAdmin = this.currentUserSubject.asObservable();
    }
    public get currentUserValue(): Required<UserAdm> {
      return {
        id_token: '',
        adminid: '',
        adminemail: '',
        adminfirstname: '',
        adminlastname: '',
        admincompany: '',
        adminpassword: '',
        scope: Scope.BF_ADM,
        ...this.currentUserSubject.value
      };
  }

  public referralUrl = environment.gdocsurl;
  public apiUrl = environment.apiurl;
  public showLang = false;// TODO environment.showLang;    
  public login(credentials: Credentials): Observable<any> {
      //this.user = { id: '', adminemail:'',  scope: '', adminfirstname: '',  adminlastname: '' };

      this.resetSessionStorage();      
      var pwd =  CryptoJS.MD5(credentials.password) + "";      
      //Scope.BF_ADM = 1;
      var credData = JSON.parse('{"email":"'+credentials.email?.toLowerCase().trim()+'", "scope":"'+"1"+'", "password":"'+pwd+'"}');
      //alert('md5: '+credentials.password);
      switch (credentials.scope){
        case Scope.BF_ADM:
          var url = this.apiUrl +  'login/admin/cred';
          const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
          return this.httpClient.post(url, credData, {headers}).pipe(
          map((response: any)   => { 
              //if (response.json()) {
                if (response.id_token){

                    //var user1 = { id_token:'', id: '', adminemail:'',  scope: '', adminfirstname: '',  adminlastname: '' };
                    var user1: UserAdm = {} as UserAdm;                    
                    
                    user1.id_token = (response.id_token !== undefined) ? response.id_token : "";
                    user1.adminemail = (response.adminemail !== undefined) ? response.adminemail : "" ;
                    user1.adminfirstname = (response.adminfirstname !== undefined) ? response.adminfirstname : "" ;
                    user1.adminlastname = (response.adminlastname !== undefined) ? response.adminlastname : "" ;
                    user1.scope = (response.entitytype !== undefined) ? response.entitytype : ""; 
                    user1.adminid = (response.adminid !== undefined) ? response.adminid : "";

                    //this.setSessionStorage(response.json());
                    const scope = user1.scope as Scope;
                    switch (scope){
                      case Scope.BF_ADM:
                          sessionStorage.setItem('onreference_adm', this.b64EncodeUnicode(JSON.stringify(user1)));
                          break;
                      default:
                        console.log('In parseInt default:'+user1.scope);
                        this.logout;
                    }
                    this.currentUserSubject.next(user1);
                    this.setListReferralTypes(false);
                    return response;                      
                }else{
                  /*if (response.json().entityvalidated !== 'validated' ){
                    alert('User is not activated. Please check your email for activation email or click on Reset Your Password');                        
                    return false;
                  }else{          
                    //{"err": true,"wait": 52}          
                    var  wait = (response.json().wait === undefined) ? 
                    (
                      (response.json().wait > 0) ? (alert('Please wait for '+response.json().wait+' seconds' )) : "" 
                    ) : "";
                    return false;
                  }*/
                  return false;
                }
              //}else{
              //  return false;
              //}
          }),
          catchError((err:any, caught: Observable<any>) => throwError(() => (err) ? (err) : 'Server error: '+err.text()) ),);                    
      }
      return throwError(() => new Error('Unsupported login scope'));
  };


public loggedIn() {
    return this.authenticated();
};


public authenticated() {//alert('In authenticated')
   try{

      //var user = JSON.parse(this.b64DecodeUnicode(sessionStorage.getItem('onreference_adm')));   
      var userAdmin = this.safeParse('onreference_adm', null);
      if (!this.jwtHelperService.isTokenExpired(userAdmin.id_token,15)){
        var decode = this.jwtHelperService.decodeToken(userAdmin.id_token); //alert('jwt Decode:'+JSON.stringify(decode));
        const scope = String(decode.scope) as Scope;        
        switch (scope){
          case Scope.BF_ADM:
              //this.user = { id_token:'', id: '', adminemail:'',  scope: '', adminfirstname: '',  adminlastname: '' };
              this.currentUserSubject.next(userAdmin);
              return true && this.currentUserValue;
          default:
            this.logout;
            return false;
        }        
      }
   }catch(e){//alert('logout: '+JSON.stringify(e))
        this.logout;
        return false;     
   }
   return false;
 };

 

 public logout() {//alert('logout')
    this.resetSessionStorage();
    this.router.navigate(["/org-login"]);
 };

 private resetSessionStorage(){
 // Remove token from sessionStorage
    try{
          sessionStorage.removeItem('onreference_org');
          sessionStorage.removeItem('onreference_orgref');          

          sessionStorage.removeItem('onreference_ent');
          sessionStorage.removeItem('onreference_entref');          

          sessionStorage.removeItem('onreference_adm');

          sessionStorage.removeItem('onreference_entpts');
          sessionStorage.removeItem('onreference_orgpts');       

          sessionStorage.removeItem('onreference_reuse_ind-home');
          sessionStorage.removeItem('onreference_reuse_org-home');

    }catch(e) {
    }
 }

 /*private setSessionStorage(data: string){
    if (this.isSessionStorageNameSupported() === false){
        alert('Please disable "Private Mode", or upgrade to a modern browser.');
        return false; 
    }
    //this.id_token = data.id_token;
    //this.user.id = data.id;
    this.currentUserValue.id_token = data.id_token;
    this.currentUserValue.adminfirstname = (data.adminfirstname !== undefined) ? data.adminfirstname : "" ;
    this.currentUserValue.adminlastname = (data.adminlastname !== undefined) ? data.adminlastname : "" ;
    //this.user.scope = data.scope; 
    //alert("Data scope: "+data.scope+" Scope.BF_ORG: "+Scope.BF_ORG);

    switch (parseInt(data.scope)){
      case Scope.BF_ADM:
        try{

            sessionStorage.setItem('onreference_adm', this.b64EncodeUnicode(JSON.stringify(this.userAdmin)));
            return true;
        }catch(e) {
          alert('Cannot set session: Please use modern browser or disable private mode.');
        }
      default:
        this.logout;
        return false;
    }    
 }*/

  private setListReferralTypes(force){
   try{

      var encodedUser = sessionStorage.getItem('onreference_adm') ?? '';
      var userAdmin = JSON.parse(this.b64DecodeUnicode(encodedUser) ?? '{}');         
      var decode = this.jwtHelperService.decodeToken(userAdmin.id_token);
      const scope = String(decode.scope) as Scope;      
      switch (scope){
        case Scope.BF_ADM:
          if (!this.jwtHelperService.isTokenExpired(userAdmin.id_token,15)){
            return true;
          }
        default:
          this.logout;
          return false;
      }
   }catch(e){
        this.logout;
        return false;     
   }

  }

private isSessionStorageNameSupported() { 
    var testKey = 'test';
    try {
      sessionStorage.setItem(testKey, '1');
      sessionStorage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  }

   private b64EncodeUnicode(str: string) {
     var words = CryptoJS.enc.Utf8.parse(str);
     return CryptoJS.enc.Base64.stringify(words)
    /*return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function(match, p1) {
        return String.fromCharCode("0x" + p1);
   }))*/
  }

   /*public b64DecodeUnicode(base64) {
    if (base64 === null){ return null};
    var words = CryptoJS.enc.Base64.parse(base64);
    return CryptoJS.enc.Utf8.stringify(words);
    //return decodeURIComponent(Array.prototype.map.call(atob(str), function(c) {
    //    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    //}).join(''));
  }*/

       public b64DecodeUnicode(base64: string) {
         try {
           if (!base64) return null;
           const words = CryptoJS.enc.Base64.parse(base64);
           return CryptoJS.enc.Utf8.stringify(words);
         } catch (e) {
           console.error('Base64 decode failed:', e);
           return null;
         }
       }
     
      private safeParse(key: string, fallback: any) {
        try {
          const raw = sessionStorage.getItem(key);
          if (!raw) return fallback;

          const decoded = this.b64DecodeUnicode(raw);
          if (!decoded) return fallback;

          return JSON.parse(decoded);
        } catch (e) {
          console.error(`Error parsing ${key}:`, e);
          return fallback;
        }
      }
  private getHeaderOptions(id_token: string){
    // //let headers = new Headers();
     //headers.append('Content-Type', 'text/plain');
     //headers.append('Authorization', id_token);
     //headers.append('Access-Control-Allow-Origin', 'https://script.googleusercontent.com');
     //headers.append('Access-Control-Allow-Origin', '*');
   //  //return new RequestOptions({ headers: headers });
 
   if (id_token != ""){
         var httpOptions = {
           headers: new HttpHeaders({
             'Content-Type':  'application/json',
             //'Content-Type':  'text/plain',
             Authorization: id_token
           })
         };
       }else{
         var httpOptions = {
           headers: new HttpHeaders({
             'Content-Type':  'application/json',
             //'Content-Type':  'text/plain',
             //Authorization: id_token
           })
         };
       }
         return httpOptions;
  }
}
